// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

//  *** Note: Instrumentation key is temporary so we can verify entries are being made.
//  Remove from here once done.

export const environment = {
  production: false,
  envName: 'dev',
  applicationNameBi: 'Inmar.Healthcare.Bi',
  applicationAccessFeature: 'UI::BiAppLink',
  applicationDisplayName: 'Business Intelligence',
  biUrlRoot: 'https://dev-web-bi.healthcare.inmar.com',
  lookerAnalyticsRoot: 'https://looker-dev.healthcare.inmar.com',
  healthcareTopBar:
    'https://dev-web-auth.healthcare.inmar.com/Scripts/healthcare-topbar-v2.js',
  authZApiRoot: {
    url: 'https://dev-api-authz.healthcare.inmar.com/v1.0',
    audience: 'https://dev-api-authz.healthcare.inmar.com',
  },
  lookerAdminRoot: {
    url: 'https://dev-api-lookeradmin.healthcare.inmar.com',
    audience: 'https://dev-api-lookeradmin.healthcare.inmar.com',
  },
  auth0: {
    domain: 'https://qa-login.healthcare.inmar.com',
    clientId: 'Pe2S8eXVu2inbG5Qg0ig6wVbRoccZwvc',
    refreshToken: true,
    scope: 'openid profile email',
  },
};
